import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { UniqueMechanismSection } from './components/UniqueMechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsItForSection } from './components/WhoIsItForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/SectionDivider';
export function App() {
  return <div className="min-h-screen bg-navy-900 font-sans text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SectionDivider data-id="element-2" />

      <ProblemSection data-id="element-3" />
      <FailedSolutionsSection data-id="element-4" />
      <SectionDivider data-id="element-5" />

      <UniqueMechanismSection data-id="element-6" />
      <SectionDivider data-id="element-7" />

      <WhatYouGetSection data-id="element-8" />
      <WhoIsItForSection data-id="element-9" />
      <SectionDivider data-id="element-10" />

      <HowItWorksSection data-id="element-11" />
      <ProofSection data-id="element-12" />
      <SectionDivider data-id="element-13" />

      <FAQSection data-id="element-14" />
      <OfferSection data-id="element-15" />

      <Footer data-id="element-16" />
    </div>;
}